import React from "react"

export default function About() {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="about__copy">
          <p className="eyebrow">About</p>
          <h2>A developer who treats your project like it's my own</h2>
          <p>
            I'm Jason, a freelance web developer. I work full-stack, but I care most about the front end —
            sites that load fast, look sharp, and are actually easy for you to update afterwards.
          </p>
          <p>
            No agency layers, no account managers — you deal with me directly from the first message through
            to launch and beyond. I'm equally comfortable dropping into an existing codebase for ongoing
            support as I am building something from scratch.
          </p>
        </div>
        <div className="about__stats">
          <div className="about__stat">
            <strong>Direct</strong>
            <span>You work with me, not a team of account managers</span>
          </div>
          <div className="about__stat">
            <strong>Full-stack</strong>
            <span>Comfortable across front end, back end and hosting</span>
          </div>
          <div className="about__stat">
            <strong>Ongoing</strong>
            <span>Available for support long after launch day</span>
          </div>
        </div>
      </div>
    </section>
  )
}